import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICardHeaderCounter } from '@shared/components/card/card-header/card-header.model';
import { BaseComponent } from '@shared/base/base.component';

@Component({
  selector: 'app-card-header-counter',
  templateUrl: './card-header-counter.component.html',
  styleUrls: ['./card-header-counter.component.scss'],
})
export class CardHeaderCounterComponent extends BaseComponent implements OnInit {
  @Input() title: string;
  @Input() data: BehaviorSubject<ICardHeaderCounter[]>;

  isLoading = new BehaviorSubject(true);

  constructor() {
    super();
  }

  ngOnInit() {
    this.handleDataSubs();
  }

  handleDataSubs() {
    this.data.subscribe((res) => this.isLoading.next(!(res && res.length)));
  }
}
